/* Components */
import { Modal, Button } from "@mui/material"
import MDBox from "../MDBox"
import MDTypography from "../MDTypography"

import ModalLeaveRelatedInfomationContent from "./ModalLeaveRelatedInfomationContent"

const pad2 = (n) => String(n).padStart(2, "0")

// Input: "2026-01-02 16:00:00.000"
const parseApiDateTime = (s) => {
  if (!s) return null
  // convert to ISO-ish: "2026-01-02T16:00:00.000"
  const iso = s.replace(" ", "T")
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? null : d
}

const formatDateDMY = (d) => {
  if (!d) return ""
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}`
}

const formatTimeHM = (d) => {
  if (!d) return ""
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`
}

const toUiData = (apiList = []) => {
  const classesThatNeedCover = []
  const events = []
  const reports = []

  apiList.forEach((row) => {
    const ev = row?.event
    const data = ev?.data
    if (!ev || !data) return

    const start = parseApiDateTime(data.startTime)
    const end = parseApiDateTime(data.endTime)
    const deadline = parseApiDateTime(ev.deadline)

    const className = data.className || data.classCode || "-"
    const schedule =
      start && end ? `${formatTimeHM(start)} - ${formatTimeHM(end)}` : "-"
    if (ev.type === "Lesson") {
      classesThatNeedCover.push({
        className,
        date: start ? formatDateDMY(start) : "-",
        classSchedule: schedule,
      })
    }

    events.push({
      eventType: ev.type || "-",
      className,
      date: start ? formatDateDMY(start) : "-",
      eventTime: schedule,
    })

    if (deadline) {
      reports.push({
        className,
        reportType: ev.type || "Deadline",
        dueDate: `${formatTimeHM(deadline)} - ${formatDateDMY(deadline)}`,
      })
    }
  })

  return { classesThatNeedCover, events, reports }
}

const ModalLeaveRelatedInfomation = (props) => {
  const { isOpen, onClose, onSubmit, dataRelatedInformation } = props

  const uiData = toUiData(dataRelatedInformation)

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="modal-leave-related-information-container">
        <div className="modal-leave-related-information-container-wrapper">
          <MDBox className="modal-leave-related-information-header">
            <MDTypography
              className="modal-leave-related-information-title"
              variant="h5"
            >
              Related Information
            </MDTypography>
          </MDBox>

          <ModalLeaveRelatedInfomationContent uiData={uiData} />

          <MDBox className="modal-leave-related-information-footer">
            <Button
              className="cancel-button"
              variant="contained"
              color="primary"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              className="submit-button"
              variant="contained"
              color="primary"
              onClick={onSubmit}
            >
              Confirm and submit
            </Button>
          </MDBox>
        </div>
      </div>
    </Modal>
  )
}

export default ModalLeaveRelatedInfomation
